import type { SubscribedCounterProps } from './types';

export const SubscribedCounter: React.FC<SubscribedCounterProps> = ({ count }) => <span className="ml-5 text-sm text-accent max-[1100px]:hidden font-body not-italic mb-1">{`(${count} abonniert)`}</span>;
